import { render, staticRenderFns } from "./EndlessScroll.vue?vue&type=template&id=56c23542&scoped=true&"
import script from "./EndlessScroll.vue?vue&type=script&lang=ts&"
export * from "./EndlessScroll.vue?vue&type=script&lang=ts&"
import style0 from "./EndlessScroll.vue?vue&type=style&index=0&id=56c23542&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c23542",
  null
  
)

component.options.__file = "EndlessScroll.vue"
export default component.exports